import React, { useState } from "react";
import styled from "styled-components";
import { errorRed } from "../../styles";
import { RowContainer } from "../../components/containers/styledComponents";
import { CompassParagraph } from "../../components/common/styledComponents";
import { LoginProps } from "../../types/loginTypes";

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 10px;
`;

const Label = styled.label<{ isFocused?: boolean }>`
  position: relative;
  left: 15px;
  top: 10px;
  background: white;
  padding: 0 5px;
  color: #555;
  font-size: 14px;
  transition: all 0.1s;
  pointer-events: none; // Ensures that clicks on the label focus the input
  color: ${(props): string => (props.isFocused ? "black" : "#bebebe")};
`;

const Input = styled.input<{ color: string; isFocused: boolean }>`
  width: 100%;
  font-size: 16px;
  padding: 15px;
  border: 1px solid ${({ color }): string => color};
  border-radius: 8px;
  color: ${({ isFocused }): string => (isFocused ? "black" : "#bebebe")};

  &:focus {
    border-color: black;
    color: black;
    font-color: black;
  }
`;

export const InputCredentials: React.FC<LoginProps> = ({
  usernameProps,
  passwordProps,
  loginErrorProps,
}) => {
  const { username, setUsername } = usernameProps;
  const { password, setPassword } = passwordProps;
  const { error } = loginErrorProps;
  const [isUsernameInputFocused, setIsUsernameInputFocused] = useState(false);
  const [isPasswordInputFocused, setIsPasswordInputFocused] = useState(false);
  const inputBorderColor = error ? errorRed : "#bebebe";

  return (
    <>
      <InputContainer>
        <Label htmlFor="username" isFocused={isUsernameInputFocused}>
          Username
        </Label>
        <Input
          type="text"
          color={inputBorderColor}
          placeholder="gaspard@gaspardcorporation"
          value={username}
          onChange={(e): void => setUsername(e.target.value)}
          onFocus={(): void => setIsUsernameInputFocused(true)}
          onBlur={(): void => setIsUsernameInputFocused(false)}
          isFocused={isPasswordInputFocused || !!username}
        />
      </InputContainer>
      <InputContainer>
        <Label htmlFor="username" isFocused={isPasswordInputFocused}>
          Password
        </Label>
        <Input
          type="password"
          color={inputBorderColor}
          placeholder="my-password"
          value={password}
          onChange={(e): void => setPassword(e.target.value)}
          onFocus={(): void => setIsPasswordInputFocused(true)}
          onBlur={(): void => setIsPasswordInputFocused(false)}
          isFocused={isPasswordInputFocused || !!password}
        />
        <RowContainer mb={1} mt={3} jc={"flex-start"}>
          <CompassParagraph
            fontSize={13}
            color={error ? errorRed : "transparent"}
          >
            {error ? error : "hidden"}
          </CompassParagraph>
        </RowContainer>
      </InputContainer>
    </>
  );
};
